import axios from 'axios';

export async function getTextFromSefaria(section, language) {
  const response = await axios.get(`https://www.sefaria.org/api/v3/texts/${encodeURI(section)}?version=${language}`);
  if (!response.status == 200) {
    throw new Error('Network response was not ok');
  }
  return response.data;
}

export async function getLinksFromSefaria(ref) {
  const response = await axios.get(`https://www.sefaria.org/api/links/${encodeURI(ref)}?with_text=0&category=Commentary`);
  if (!response.status == 200) {
    throw new Error('Network request failed');
  }
  return response.data;
}
